import { createContext } from "react";
import { IRnDContext } from "./models/IRnDContext";

export const RnDContext = createContext<IRnDContext>({
});